import React, { useState } from "react";
import {
    ContentHeader,
    ContentTitleBlock,
    Chip,
    Subtitle,
    ContentActionsRow,
    BtnIcon,
    TabsNav,
    Tab
} from "../../components/SharedPageStyles";
import { SECTIONS } from "../../constants/sections";

import MacroTab from "./tabs/MacroTab";
import GeopoliticsTab from "./tabs/GeopoliticsTab";
import MicroTab from "./tabs/MicroTab";

import { FundamentalsProvider, useFundamentalsData } from "../../context/FundamentalsContext";
import ExportButton from "../../components/ExportButton";

const FundamentalsBoardContent = () => {
    const [activeTab, setActiveTab] = useState(SECTIONS["fundamentals"].tabs[0].key);
    const { resetData, rows, isLoading } = useFundamentalsData();

    const renderTabContent = () => {
        switch (activeTab) {
            case "macro": return <MacroTab />;
            case "geopolitics": return <GeopoliticsTab />;
            case "micro": return <MicroTab />;
            default: return <MacroTab />;
        }
    };

    return (
        <>
            <ContentHeader>
                <ContentTitleBlock>
                    <Chip>Fundamentals</Chip>
                    <Subtitle><em>Global economic events and market analysis.</em></Subtitle>
                </ContentTitleBlock>
            </ContentHeader>

            <ContentActionsRow>
                <BtnIcon
                    aria-label="Refresh data"
                    onClick={resetData}
                    title="Refresh data"
                    disabled={isLoading}
                    $spinning={isLoading}
                >
                    ⟳
                </BtnIcon>
                <ExportButton data={rows} filename="fundamentals" />
            </ContentActionsRow>

            <TabsNav>
                {SECTIONS["fundamentals"].tabs.map(tab => (
                    <Tab
                        key={tab.key}
                        active={activeTab === tab.key}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </Tab>
                ))}
                {(() => {
                    const nextFetchRow = rows.find(r => r.next_fetch);
                    if (nextFetchRow) {
                        return (
                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', paddingRight: '4px' }}>
                                <Subtitle style={{ fontSize: '11px', margin: 0 }}>
                                    <em>
                                        Next Fetch: {new Date(nextFetchRow.next_fetch).toLocaleString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false,
                                            timeZone: 'Europe/Paris'
                                        }).replace(',', '')}
                                    </em>
                                </Subtitle>
                            </div>
                        );
                    }
                    return null;
                })()}
            </TabsNav>

            {renderTabContent()}
        </>
    );
};

const FundamentalsBoard = () => {
    return (
        <FundamentalsProvider>
            <FundamentalsBoardContent />
        </FundamentalsProvider>
    );
};

export default FundamentalsBoard;
